// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-remove-button[data-v-3c727592]{height:24px!important;width:24px!important;margin:0;border-width:2px!important;justify-content:center}.seat-header-subtitle-text[data-v-3c727592]{font-size:14px;line-height:18px;font-weight:450;font-style:normal;align-items:center;color:#1976d2;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
